const reviews = [
    {
        pfp:"/assets/reviews/jacob.jpg",
        name:"Jacob Held",
        position:"StudyCrew CEO",
        p:"I had the pleasure of collaborating with Kian on StudyCrew, an open-source education platform. He designed a fantastic homepage and offered valuable insights into the platform's overall design. Kian was always very friendly and enthusiastic, contributing to a positive and productive atmosphere.",
        width:"13svw"
    },
    {
        pfp:"/assets/reviews/codanium.png",
        name:"Saket Gupta",
        position:"Criven Studios Co-Founder",
        p:"Working with Kian at Criven Studios was  an absolute pleasure. He's the kind of designer who doesn't just make things look good—he makes them feel right. His work ethic is unmatched, always pushing for the best, always refining, always listening. Late nights, endless iterations, and a relentless pursuit of great design—he gave it his all. If you need someone who truly cares about UI/UX, he's your guy.",
        width:"15svw"
    },
    {   
        pfp:"",
        name: "Abiel Asimiea",
        position:"Portback CEO",
        p:"Kian is an exceptional UI/UX designer with a strong work ethic and impressive skills. He delivers high-quality solutions with a user-centered approach and collaborates effectively with teams. I highly recommend Kian for any UI/UX design needs.",
        width:"10svw"
    },
    {   
        pfp:"/assets/reviews/elena.jpg",
        name: "M.Elena Segatini",
        position:"K|B lab photographer",
        p: "Kian brought a sharp eye and strong design sensibility to the K|B Lab photography website. He managed to create a layout that highlights the uniqueness of each image while keeping the experience clean and effortless to navigate. Whether it's weddings, fashion, or travel, the work now feels beautifully curated and professionally presented thanks to his thoughtful approach.",
        width:"14.4svw"
    },
];

export default reviews;